import { render, staticRenderFns } from "./PieSupervise.vue?vue&type=template&id=5d24745f&"
import script from "./PieSupervise.vue?vue&type=script&lang=js&"
export * from "./PieSupervise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports